<template>
  <div>
    <div class="content">
      <div class="contact__container">
        <div class="contact__form">
          <div class="contactUsTitleWrapper">
            <h2>پشتیبانی</h2>
          </div>
          <form class="contact__form-container">
            <div class="contact__input contact__input--textarea">
              <label for="fullName">نام و نام خانوادگی</label>
              <input
                v-model="form.fullname"
                name="fullName"
                maxlength="50"
                type="text"
                placeholder="نام و نام خانوادگی"
              />
            </div>
            <div class="contact__input contact__input--textarea">
              <label for="phoneNumber">تلفن تماس</label>
              <input
                  dir="ltr"

                name="phoneNumber"
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="11"
                v-model="form.mobile"
                type="text"
                placeholder="تلفن تماس"
              />
            </div>
            <div class="contact__input contact__input--textarea">
              <label for="phoneNumber">موضوع</label>
              <input


                  maxlength="50"
                  v-model="form.subject"
                  type="text"
                  placeholder="موضوع"
              />
            </div>
            <div class="contact__input contact__input--textarea">
              <label for="description">توضیحات</label>
              <textarea
                maxlength="300"
                v-model="form.text"
                name="description"
                cols="30"
                rows="10"
                placeholder="متن پیام خود را وارد کنید"
              ></textarea>
            </div>
            <div class="contactOptions">
              <button
                type="submit"
                class="contact__submit-btn"
                v-if="!btnLoading"
                @click="save()"
              >
                ارسال
              </button>
              <button
                type="submit"
                class="contact__submit-btn"
                v-if="btnLoading"
              >
                درحال ارسال...
              </button>
              <a
                :href="`${$store.state.c_set.telegram}`"
                class="optionThumb telegram"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path
                    d="M320 72C183 72 72 183 72 320C72 457 183 568 320 568C457 568 568 457 568 320C568 183 457 72 320 72zM435 240.7C431.3 279.9 415.1 375.1 406.9 419C403.4 437.6 396.6 443.8 390 444.4C375.6 445.7 364.7 434.9 350.7 425.7C328.9 411.4 316.5 402.5 295.4 388.5C270.9 372.4 286.8 363.5 300.7 349C304.4 345.2 367.8 287.5 369 282.3C369.2 281.6 369.3 279.2 367.8 277.9C366.3 276.6 364.2 277.1 362.7 277.4C360.5 277.9 325.6 300.9 258.1 346.5C248.2 353.3 239.2 356.6 231.2 356.4C222.3 356.2 205.3 351.4 192.6 347.3C177.1 342.3 164.7 339.6 165.8 331C166.4 326.5 172.5 322 184.2 317.3C256.5 285.8 304.7 265 328.8 255C397.7 226.4 412 221.4 421.3 221.2C423.4 221.2 427.9 221.7 430.9 224.1C432.9 225.8 434.1 228.2 434.4 230.8C434.9 234 435 237.3 434.8 240.6z"
                  />
                </svg>
                <span>پشتیبانی در تلگرام</span>
              </a>
              <a
                :href="`${$store.state.c_set.whatsapp}`"
                class="optionThumb whatsapp"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path
                    d="M476.9 161.1C435 119.1 379.2 96 319.9 96C197.5 96 97.9 195.6 97.9 318C97.9 357.1 108.1 395.3 127.5 429L96 544L213.7 513.1C246.1 530.8 282.6 540.1 319.8 540.1L319.9 540.1C442.2 540.1 544 440.5 544 318.1C544 258.8 518.8 203.1 476.9 161.1zM319.9 502.7C286.7 502.7 254.2 493.8 225.9 477L219.2 473L149.4 491.3L168 423.2L163.6 416.2C145.1 386.8 135.4 352.9 135.4 318C135.4 216.3 218.2 133.5 320 133.5C369.3 133.5 415.6 152.7 450.4 187.6C485.2 222.5 506.6 268.8 506.5 318.1C506.5 419.9 421.6 502.7 319.9 502.7zM421.1 364.5C415.6 361.7 388.3 348.3 383.2 346.5C378.1 344.6 374.4 343.7 370.7 349.3C367 354.9 356.4 367.3 353.1 371.1C349.9 374.8 346.6 375.3 341.1 372.5C308.5 356.2 287.1 343.4 265.6 306.5C259.9 296.7 271.3 297.4 281.9 276.2C283.7 272.5 282.8 269.3 281.4 266.5C280 263.7 268.9 236.4 264.3 225.3C259.8 214.5 255.2 216 251.8 215.8C248.6 215.6 244.9 215.6 241.2 215.6C237.5 215.6 231.5 217 226.4 222.5C221.3 228.1 207 241.5 207 268.8C207 296.1 226.9 322.5 229.6 326.2C232.4 329.9 268.7 385.9 324.4 410C359.6 425.2 373.4 426.5 391 423.9C401.7 422.3 423.8 410.5 428.4 397.5C433 384.5 433 373.4 431.6 371.1C430.3 368.6 426.6 367.2 421.1 364.5z"
                  />
                </svg>
                <span>پشتیبانی در واتساپ</span>
              </a>
              <a
                :href="`tel:${$store.state.c_set.phone}`"
                class="optionThumb call"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path
                    d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z"
                  />
                </svg>
                <span>تماس با ما</span>
              </a>
            </div>
          </form>
        </div>
        <div class="contact__info">
          <img
            v-if="$store.state.theme == 'light'"
            src="/img/contact.9b6f977.svg"
            alt="contact"
            class="contact__icon"
          />
          <img
            v-if="$store.state.theme == 'dark'"
            src="/img/contactDark.svg"
            alt="contact"
            class="contact__icon"
          />
          <div class="contact__channels">
            <h5>راه‌های ارتباطی</h5>
            <div class="contact__channel">
              <svg
                width="48px"
                height="48px"
                viewBox="0 0 48 48"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>phone-call</title>
                <g
                  id="Profile"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="contact"
                    transform="translate(-832.000000, -602.000000)"
                  >
                    <g
                      id="Group-17"
                      transform="translate(260.000000, 527.000000)"
                    >
                      <g
                        id="Group-13"
                        transform="translate(449.000000, 70.000000)"
                      >
                        <g
                          id="phone-call"
                          transform="translate(123.000000, 5.000000)"
                        >
                          <g
                            id="Group"
                            transform="translate(6.000000, 4.000000)"
                            stroke="#131B1F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          >
                            <path
                              d="M31.93,29.22 L29.584,26.874 C28.412,25.702 26.512,25.702 25.342,26.874 L23.498,28.718 C23.086,29.13 22.462,29.268 21.93,29.034 C19.258,27.864 16.618,26.09 14.264,23.736 C11.92,21.392 10.152,18.764 8.98,16.102 C8.736,15.552 8.878,14.906 9.304,14.48 L10.956,12.828 C12.298,11.486 12.298,9.588 11.126,8.416 L8.78,6.07 C7.218,4.508 4.686,4.508 3.124,6.07 L1.82,7.372 C0.338,8.854 -0.28,10.992 0.12,13.112 C1.108,18.338 4.144,24.06 9.042,28.958 C13.94,33.856 19.662,36.892 24.888,37.88 C27.008,38.28 29.146,37.662 30.628,36.18 L31.93,34.878 C33.492,33.316 33.492,30.784 31.93,29.22 Z"
                              id="Path"
                            ></path>
                            <path
                              d="M20,9.982 C22.062,9.954 24.134,10.718 25.708,12.292"
                              id="Path"
                            ></path>
                            <path
                              d="M31.364,6.636 C28.226,3.498 24.112,1.928 20,1.928"
                              id="Path"
                            ></path>
                            <path
                              d="M28.018,18 C28.046,15.938 27.282,13.866 25.708,12.292"
                              id="Path"
                            ></path>
                            <path
                              d="M31.364,6.636 C34.502,9.774 36.072,13.888 36.072,18"
                              id="Path"
                            ></path>
                          </g>
                          <rect
                            id="Rectangle"
                            x="0"
                            y="0"
                            width="48"
                            height="48"
                          ></rect>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>

              <div class="contact__channel-details">
                <p>تلفن پشتیبانی:</p>
                <span>{{ $store.state.c_set.phone }}</span>
              </div>
            </div>
            <div class="contact__channel">
              <svg
                width="48px"
                height="48px"
                viewBox="0 0 48 48"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>myicons-828</title>
                <g
                  id="Profile"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="contact"
                    transform="translate(-832.000000, -690.000000)"
                  >
                    <g
                      id="Group-17"
                      transform="translate(260.000000, 527.000000)"
                    >
                      <g
                        id="Group-14"
                        transform="translate(433.000000, 158.000000)"
                      >
                        <g
                          id="myicons-828"
                          transform="translate(139.000000, 5.000000)"
                        >
                          <rect
                            id="Rectangle"
                            x="0"
                            y="0"
                            width="48"
                            height="48"
                          ></rect>
                          <g
                            id="Group-11"
                            transform="translate(6.000000, 10.000000)"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              d="M0,3.564 L0,3.564 C0,4.746 0.586,5.852 1.564,6.514 L13.526,14.62 C16.236,16.456 19.792,16.456 22.502,14.62 L34.434,6.532 C35.414,5.872 36,4.766 36,3.584 L36,3.564 C36,1.596 34.404,-3.0375702e-13 32.436,-3.0375702e-13 L3.564,-3.0375702e-13 C1.596,-3.0375702e-13 0,1.596 0,3.564 Z"
                              id="Path"
                              stroke="#131B1F"
                              stroke-width="2"
                            ></path>
                            <path
                              d="M0,4 L0,24 C0,26.21 1.79,28 4,28 L32,28 C34.21,28 36,26.21 36,24 L36,4"
                              id="Path"
                              stroke="#131B1F"
                              stroke-width="2"
                            ></path>
                            <line
                              x1="1.172"
                              y1="26.828"
                              x2="13.452"
                              y2="14.548"
                              id="Path"
                              stroke="#131B1F"
                              stroke-width="2"
                            ></line>
                            <line
                              x1="22.562"
                              y1="14.562"
                              x2="34.822"
                              y2="26.822"
                              id="Path"
                              stroke="#323232"
                              stroke-width="1.5"
                            ></line>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <div class="contact__channel-details">
                <p>ایمیل:</p>
                <span>{{ $store.state.c_set.email }}</span>
              </div>
            </div>
            <div class="contact__channel">
              <svg
                width="48px"
                height="48px"
                viewBox="0 0 48 48"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>pin-location-direction.5</title>
                <g
                  id="Profile"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="contact"
                    transform="translate(-832.000000, -778.000000)"
                  >
                    <g
                      id="Group-17"
                      transform="translate(260.000000, 527.000000)"
                    >
                      <g
                        id="Group-12"
                        transform="translate(0.000000, 246.000000)"
                      >
                        <g
                          id="pin-location-direction.5"
                          transform="translate(572.000000, 5.000000)"
                        >
                          <polygon
                            id="a"
                            points="0 0 48 0 48 48 0 48"
                          ></polygon>
                          <polygon
                            id="a"
                            points="0 0 48 0 48 48 0 48"
                          ></polygon>
                          <path
                            d="M26.3702,14.81578 C27.679238,16.124818 27.679238,18.24718 26.3702,19.55622 C25.061162,20.865258 22.9388,20.865258 21.62976,19.55622 C20.320722,18.247182 20.320722,16.12482 21.62976,14.81578 C22.938798,13.506742 25.06116,13.506742 26.3702,14.81578"
                            id="Path"
                            stroke="#131B1F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M34.97,16.76 L34.97,16.76 C34.97,19.74 33.646,22.564 31.358,24.472 L27.76,27.47 C26.326,28.666 25.254,30.236 24.664,32.008 L24,34 L23.336,32.008 C22.746,30.238 21.674,28.666 20.24,27.47 L16.642,24.472 C14.352,22.564 13.03,19.74 13.03,16.76 L13.03,16.76 L13.03,16.816 C13.03,9.972 18.698,6 24,6 C29.302,6 34.97,9.972 34.97,16.816"
                            id="Path"
                            stroke="#131B1F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M14,29.196 C9.182,30.45 6,32.576 6,35 C6,38.866 14.058,42 24,42 C33.942,42 42,38.866 42,35 C42,32.576 38.818,30.448 34,29.196"
                            id="Path"
                            stroke="#131B1F"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>

              <div class="contact__channel-details">
                <p>دفتر مرکزی :</p>
                <span>
                  {{ $store.state.c_set.address }}
                </span>
              </div>
            </div>
          </div>
          <div class="contact__map">
            <iframe
              src="https://balad.ir/embed?p=1IbnnRVUVfzZLG"
              title="شمال املاک"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: 0"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import store from "@/store";
import axios from "axios";
import { toast } from "vue3-toastify";

const form = ref({
  fullname: "",
  text: "",
  subject: "",
  email: "",
  mobile: "",
});
const btnLoading = ref(false);
const save = () => {
  btnLoading.value = true;
  // const formData = new FormData(document.querySelector("form"));
  axios
    .post(store.getters.baseUrl + "/contactus-save", form.value)
    .then((r) => {
      if (r.data.result == 1) {
        toast(r.data.msg, {
          type: "success",
          dangerouslyHTMLString: true,
        });
        btnLoading.value = false;
        form.value.fullname = "";
        form.value.email = "";
        form.value.subject = "";
        form.value.mobile = "";
        form.value.text = "";
      } else {
        toast(r.data.msg, {
          type: "error",
          dangerouslyHTMLString: true,
        });
        btnLoading.value = false;
      }
    })
    .catch(() => {
      toast("دوباره تلاش کنید", {
        type: "error",
        dangerouslyHTMLString: true,
      });
      btnLoading.value = false;
    });
};
</script>

<style scoped lang="scss">
.contactUsTitleWrapper {
  min-height: auto !important;

  h2 {
    font-size: 2rem !important;
    margin-bottom: 8px !important;
  }
}
.contactOptions {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 42px;
  .contact__submit-btn {
    width: 100% !important;
    margin: 0 !important;
  }
  .optionThumb {
    width: 100%;
    height: 60px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    color: #fff;
    font-weight: 500;
    font-family: "iranyekanB";
    gap: 8px;

    &.telegram {
      background: linear-gradient(135deg, #229ed9, #1b86bd);
    }

    &.whatsapp {
      background: linear-gradient(135deg, #25d366, #1da851);
    }

    &.call {
      background: linear-gradient(135deg, #4b6cb7, #2f4ea0);

      svg {
        width: 22px;
        height: 22px;
      }
    }

    svg {
      width: 26px;
      height: 26px;
      fill: #fff;
    }
  }
}
@media (max-width: 700px) {
  .contact__container {
    margin-top: 32px !important;

    .optionThumb {
      height: 48px;
    }
  }

  .contactOptions {
    gap: 18px;
    grid-template-columns: repeat(3, minmax(0, 1fr));

    .contact__submit-btn {
      grid-column: span 3;
      font-size: 1.1rem;
    }

    .optionThumb {
      svg {
        width: 30px;
        height: 30px;
      }
      &.call {
        svg {
          width: 24px;
          height: 24px;
        }
      }
      span {
        display: none;
      }
    }
  }

  .contactUsTitleWrapper {
    text-align: center;
  }

  .contact__info {
    display: none;
  }
}
</style>
